export default __webpack_public_path__ + "static/media/swipe.d9e89451.svg";